import { NgModule } from "@angular/core";


import { ConfirmationService, MessageService } from "primeng/api";
import { CategoryService } from "./master-data/category/category.service";
import { CategoryClient, OrderClient, PrivacyPolicyClient, SubscriptionClient, ProductTemplateClient, SellerProfileClient, SalesOverviewClient, InvoiceClient } from "../base/models/models.swagger.generated";
import { ProductTemplateService } from "./master-data/product-template/product-template.service";
import { SubscriptionService } from "./master-data/subscription/subscription.service";
import { PrivacyPolicyService } from "./master-data/privacy-policy/privacy-policy.service";
import { EditorModule } from 'primeng/editor';
import { OrderService } from "./transaction/order/order.service";
import { DeliveryDetailsService } from "./transaction/order/delivery-details/delivery-details.service";
import { SalesOverviewService } from "./transaction/sales-overview/sales-overview.service";
import { InvoiceService } from "./transaction/invoice/invoice.service";






@NgModule({
    imports: [
        EditorModule


    ],
    providers: [
        ConfirmationService,
        MessageService,
        CategoryService,
        CategoryClient,
        SubscriptionClient,
        SubscriptionService,
        PrivacyPolicyClient,
        PrivacyPolicyService,
        OrderClient,
        OrderService,
        DeliveryDetailsService,
        ProductTemplateClient,
        ProductTemplateService,
        SellerProfileClient,
        SalesOverviewClient,
        SalesOverviewService,
        InvoiceClient,
        InvoiceService
    ]
})
export class DomainModule { }
